import React from 'react';
import i18n from '@/packages/content/view/preparation/helpers/i18n';

export default props => {
  const { width } = props;
  if (width == '100%') {
    return (
      <View plugin="flexbox: la" align="center" spx={20}>
        <label>{i18n.t('关键词')}:</label>
        <View>
          <nx.$rc.inputSearch placeholder={i18n.t('请输入关键词进行搜索')} allowClear {...props} />
        </View>
      </View>
    );
  }

  return (
    <View dflex align="center" spx={20}>
      <label>{i18n.t('关键词')}:</label>
      <View w={width}>
        <nx.$rc.inputSearch placeholder={i18n.t('请输入关键词进行搜索')} allowClear {...props} />
      </View>
    </View>
  );
};
